export default __webpack_public_path__ + "static/media/contactIcon.5a55e368.svg";